import type { ReactNode } from "react";
import "./provisional-banner.css";

export interface ProvisionalBannerProps {
  title: string;
  description?: string;
  action?: ReactNode;
}

export function ProvisionalBanner({ title, description, action }: ProvisionalBannerProps) {
  return (
    <aside className="wp-banner wp-banner--warning" role="status">
      <span aria-hidden="true" className="wp-banner__icon">
        ⓘ
      </span>
      <div className="wp-banner__body">
        <p className="wp-banner__title">{title}</p>
        {description ? <p className="wp-banner__desc">{description}</p> : null}
      </div>
      {action ? <div className="wp-banner__action">{action}</div> : null}
    </aside>
  );
}
